module.exports = __webpack_public_path__ + "static/media/tab2.8825060a.png";